import { InnerContentItem } from "@certn/cascadia-react";
import { components } from "@certn/legacy-api/generated-schemas/people";
import { useTranslation } from "react-i18next";

import { purposeTypes } from "./constants";

export function PurposeSummaryField({
  field,
}: {
  field: components["schemas"]["PurposeCheckField"];
}) {
  const { t } = useTranslation();

  return (
    <>
      <InnerContentItem
        label={t("Purpose of check")}
        testID="purpose-summary-purpose-of-check"
      >
        {field.value ? purposeTypes[field.value.purpose_of_check] : "-"}
      </InnerContentItem>

      {field.value?.purpose_of_check === "EMPLOYMENT" && (
        <>
          <InnerContentItem
            label={t("Role or position title")}
            testID="purpose-summary-role-or-position"
          >
            {field.value?.position_title}
          </InnerContentItem>

          <InnerContentItem
            label={t("Organization, type or place of work")}
            testID="purpose-summary-type-or-place-of-work"
          >
            {field.value?.place_of_work}
          </InnerContentItem>
        </>
      )}

      {field.value?.purpose_of_check === "LICENSE" && (
        <>
          <InnerContentItem
            label={t("License type")}
            testID="purpose-summary-license-type"
          >
            {field.value?.license_type}
          </InnerContentItem>

          <InnerContentItem
            label={t("Issuing authority")}
            testID="purpose-summary-issuing-authority"
          >
            {field.value?.issuing_authority}
          </InnerContentItem>
        </>
      )}

      {field.value?.purpose_of_check === "OTHER" && (
        <>
          <InnerContentItem
            label={t("Reason for check")}
            testID="purpose-summary-reason-for-check"
          >
            {field.value?.reason_for_check}
          </InnerContentItem>

          <InnerContentItem
            label={t("Requesting organization")}
            testID="purpose-summary-requesting-organization"
          >
            {field.value?.place_of_work}
          </InnerContentItem>
        </>
      )}
    </>
  );
}
